import { ButtonLink } from '../components/Button';
import { Paper } from '../components/Paper';
import { EmptyState } from '../components/States';

export function NotFound() {
  return (
    <Paper>
      <EmptyState
        title="There's nothing pinned here"
        actions={
          <ButtonLink to="/" variant="primary">
            Back to the board
          </ButtonLink>
        }
      >
        That page doesn't exist. It may have moved, or the link has a typo.
      </EmptyState>
    </Paper>
  );
}
